import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import LastHolderFields from './LastHolderFields'
import useLastHolderFields from './useLastHolderFields'
import { SDOutlineButton, SpacingWrapper } from '@/shared/theme/styled-components'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'

const LastHolderFieldsModal = () => {
  const { t, hidden, isFilled, isOpen, openModal, closeModal } = useLastHolderFields()

  if (hidden) return null

  return (
    <SpacingWrapper $marginTop='1rem' $marginBottom='1rem'>
      {/* @ts-ignore */}
      <SDOutlineButton
        onClick={openModal}
        endEnhancer={isFilled ? () => <IconCarbonCheckmarkOutline size={24} color='green' /> : undefined}
      >
        {t('subscriptionForm:address_module.last_holder_fields.name_v2')}
      </SDOutlineButton>

      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={t('subscriptionForm:address_module.last_holder_fields.name_v2')}
        sections={<LastHolderFields />}
      />
    </SpacingWrapper>
  )
}

export default LastHolderFieldsModal
